import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import {UserInvitation, UserInvitationEx} from "../types/domain/userInvitation";

export type PostUserInvitationBodyType = Pick<UserInvitation, "companyId" | "userEmail" | "role">;
export type PatchUserInvitationBodyType = Pick<UserInvitation, "role">;
export interface BulkInvitationResponse {
    invitationsCreated: number;
    invitationsSkipped: number;
}

export const createUserInvitation = async (body: PostUserInvitationBodyType): Promise<UserInvitation> =>
    await apiClient
        .post<UserInvitation>("/invitations", body)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const patchUserInvitation = async (
    invitationId: string,
    body: PatchUserInvitationBodyType,
): Promise<UserInvitation> =>
    await apiClient
        .patch<UserInvitation>(`/invitations/${invitationId}`, body)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const acceptUserInvitation = async (invitationId: string): Promise<UserInvitation> =>
    await apiClient
        .post<UserInvitation>(`/invitations/${invitationId}/accept`, {})
        .then((response) => response.data)
        .catch(handleAxiosError);

export const rejectUserInvitation = async (invitationId: string): Promise<UserInvitation> =>
    await apiClient
        .post<UserInvitation>(`/invitations/${invitationId}/reject`, {})
        .then((response) => response.data)
        .catch(handleAxiosError);

export const cancelUserInvitation = async (invitationId: string): Promise<UserInvitation> =>
    await apiClient
        .post<UserInvitation>(`/invitations/${invitationId}/cancel`, {})
        .then((response) => response.data)
        .catch(handleAxiosError);

export const getInvitationsForUser = async (userId: string): Promise<UserInvitationEx[]> =>
    await apiClient
        .get<UserInvitationEx[]>(`/users/${userId}/invitations`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const getInvitationsForCompany = async (companyId: string): Promise<UserInvitationEx[]> =>
    await apiClient
        .get<UserInvitationEx[]>(`/companies/${companyId}/invitations`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const getInvitationById = async (invitationId: string): Promise<UserInvitationEx> =>
    await apiClient
        .get<UserInvitationEx>(`/invitations/${invitationId}`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const createBulkUserInvitations = async (companyId: string, file: File): Promise<BulkInvitationResponse> => {
    const formData = new FormData();
    formData.append("file", file);

    return await apiClient
        .post<BulkInvitationResponse>(`/companies/${companyId}/invitations/bulk`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then((response) => response.data)
        .catch(handleAxiosError);
};
